import React, { useState } from 'react';
import { Nav, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CoreTracking } from '../../../../models/CoreTracking';
import MapEntraIdUserTrackingWizard from './MapEntraIdUserTrackingWizard';
import EditEntraIdUserTrackingWizard from './EditEntraIdUserTrackingWizard';
import InactivateEntraIdUserTrackingWizard from './InactivateEntraIdUserTrackingWizard';
import RestoreEntraIdUserTrackingWizard from './RestoreEntraIdUserTrackingWizard';
import { useTranslation } from 'react-i18next';

enum EntraIdUserTrackingOperation {
    None = 0,
    Edit = 1,
    Inactivate = 2,
    Restore = 3,
    Map = 4,
}

interface EntraIdUserTrackingOperationsMenuProps {
    tracking: CoreTracking
    onClose?: (success: boolean) => void
    disabled?: boolean
}

const EntraIdUserTrackingOperationsMenu: React.FC<EntraIdUserTrackingOperationsMenuProps> = (props) => {
    const [operation, setOperation] = useState(EntraIdUserTrackingOperation.None);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { t } = useTranslation(['schoolAdministration', 'common']);
    
    if (!isEntraIdUserTracking(props.tracking)) {
        return null;
    }

    const close = (success: boolean) => {
        setOperation(EntraIdUserTrackingOperation.None);

        if (props.onClose) {
            props.onClose(success);
        }
    }

    return <React.Fragment>
        <Nav className="right">
            <Dropdown nav isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                <DropdownToggle nav style={{ display: 'inline' }}>
                    <FontAwesomeIcon icon="ellipsis" className="icon" title={t('trackingOperations.general.trackingActions', {ns: 'schoolAdministration'})} />
                </DropdownToggle>
                <DropdownMenu>
                    {props.tracking.active && <DropdownItem onClick={() => setOperation(EntraIdUserTrackingOperation.Map)} disabled={props.disabled}>{t('trackingOperations.operations.reconfigure', {ns: 'schoolAdministration'})}</DropdownItem>}
                    {props.tracking.active && <DropdownItem onClick={() => setOperation(EntraIdUserTrackingOperation.Edit)} disabled={props.disabled}>{t('trackingOperations.operations.edit', {ns: 'schoolAdministration'})}</DropdownItem>}
                    {props.tracking.active && <DropdownItem onClick={() => setOperation(EntraIdUserTrackingOperation.Inactivate)} disabled={props.disabled}>{t('trackingOperations.operations.inactivate', {ns: 'schoolAdministration'})}</DropdownItem>}
                    {!props.tracking.active && <DropdownItem onClick={() => setOperation(EntraIdUserTrackingOperation.Restore)} disabled={props.disabled}>{t('trackingOperations.operations.restore', {ns: 'schoolAdministration'})}</DropdownItem>}
                </DropdownMenu>
            </Dropdown>
        </Nav>
        {operation === EntraIdUserTrackingOperation.Map && <MapEntraIdUserTrackingWizard tracking={props.tracking} close={close} />}
        {operation === EntraIdUserTrackingOperation.Edit && <EditEntraIdUserTrackingWizard tracking={props.tracking} close={close} />}
        {operation === EntraIdUserTrackingOperation.Inactivate && <InactivateEntraIdUserTrackingWizard tracking={props.tracking} close={close} />}
        {operation === EntraIdUserTrackingOperation.Restore && <RestoreEntraIdUserTrackingWizard tracking={props.tracking} close={close} />}
    </React.Fragment>;
}

export const isEntraIdUserTracking = (tracking: CoreTracking): boolean => {
    if (tracking.sourceName !== 'EntraID') {
        return false;
    }

    switch (tracking.sourceObjectType) {
        case 'StaffUser:Synched': return true;
        case 'StudentUser:Synched': return true;
        default: return false;
    }
}

export default EntraIdUserTrackingOperationsMenu;
